$(document).ready(function () {

  // THUMBS
  const swiperProduct = new Swiper(".swiperProduct", {
    spaceBetween: 10,
    direction: "vertical",
    slidesPerView: 0, // (na mobilnom će ionako biti sakriveno, na ≥992 postavi 6)
    freeMode: true,
    mousewheel: {
      forceToAxis: true,
      sensitivity: 1,
      releaseOnEdges: true,
    },
    watchSlidesProgress: true,
    breakpoints: {
      992: {
        slidesPerView: 6,
      }
    },
    // bitno kad se DOM mijenja između proizvoda
    observer: true,
    observeParents: true,
    resizeObserver: true,
  });

  let swiperProduct2 = null;

  function initSwiper() {
    // nemoj ponovo deklarisati var/let ovdje!
    swiperProduct2 = new Swiper(".swiperProduct2", {
      spaceBetween: 10,
      slidesPerView: 1,
      direction: 'horizontal',
      freeMode: false,
      autoHeight: true, // ➜ ključno za mobitel
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        992: {
          direction: "vertical",
          freeMode: {
            enabled: true,
            momentum: true,
            momentumRatio: 0.1,
            momentumVelocityRatio: 0.1,
            sticky: false
          },
          mousewheel: {
            forceToAxis: true,
            sensitivity: 2,
            releaseOnEdges: true,
          },
        }
      },
      thumbs: {
        swiper: swiperProduct,
      },

      // ➜ Ovo rješava visinu kad se slike naknadno učitaju
      observer: true,
      observeParents: true,
      resizeObserver: true,

      on: {
        imagesReady() {
          this.update();
          this.updateAutoHeight();
        },
        slideChangeTransitionEnd() {
          this.updateAutoHeight();
        },
        resize() {
          this.update();
          this.updateAutoHeight();
        }
      }
    });
  }

  function destroySwiper() {
    if (swiperProduct2 && !swiperProduct2.destroyed) {
      // true,true = ukloni evente i stilove
      swiperProduct2.destroy(true, true);
      swiperProduct2 = null;
    }
  }

  // inicijalno
  initSwiper();

  // Re-init na promjeni breakpointa
  const mq = window.matchMedia('(min-width: 992px)');
  mq.addEventListener('change', () => {
    // kratko odloži da DOM promjene “sjednu”
    setTimeout(() => {
      destroySwiper();
      initSwiper();
    }, 0);
  });

  // (opciono) Ako tema mijenja sadržaj bez full reloada (Dawn, AJAX navigacija, sl.),
  // osiguraj re-init nakon promjene sekcije/proizvoda:
  document.addEventListener('shopify:section:load', () => {
    setTimeout(() => {
      destroySwiper();
      initSwiper();
    }, 0);
  });
  document.addEventListener('shopify:section:reorder', () => {
    setTimeout(() => {
      if (swiperProduct2) { swiperProduct2.update(); swiperProduct2.updateAutoHeight(); }
    }, 0);
  });

  // ANNOUNCEMENT BAR
  var swiper = new Swiper('.announcementbar_row', {
    loop: true,
    speed: 300,
    slidesPerView: 1,
    autoplay: {
      delay: 3000, // You can adjust the delay
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-anno-next',
      prevEl: '.swiper-anno-prev',
    },
  });
  // // THUMBS FOR PRODUCT SLIDER
  // var swiperProduct = new Swiper(".swiperProduct", {
  //     spaceBetween: 10,
  //     direction: "vertical",
  //     slidesPerView: 0,
  //     freeMode: true,
  //     mousewheel: {
  //         forceToAxis: true,
  //         sensitivity: 1,
  //         releaseOnEdges: true,
  //     },
  //     watchSlidesProgress: true,
  //     breakpoints: {
  //         992: { // Hide on mobile
  //             slidesPerView: 6,
  //         }
  //     }
  // })  

  // var swiperProduct2 = null;
  // initSwiper();

  // function initSwiper() {
  //     var swiperProduct2 = new Swiper(".swiperProduct2", {
  //         spaceBetween: 10,
  //         slidesPerView: 1,
  //         freeMode: false,
  //         direction: 'horizontal',
  //         mousewheel: {
  //             forceToAxis: true,
  //             sensitivity: 1,
  //             releaseOnEdges: true,
  //         },
  //         pagination: {
  //             el: ".swiper-pagination",
  //             clickable: true,
  //         },
  //         breakpoints: {
  //             992: {
  //                 direction: "vertical",
  //                 freeMode: {
  //                     enabled: true,
  //                     momentum: true,
  //                     momentumRatio: 0.1,
  //                     momentumVelocityRatio: 0.1,
  //                     sticky: false
  //                 },
  //                 mousewheel: {
  //                     forceToAxis: true,
  //                     sensitivity: 2,
  //                     releaseOnEdges: true,
  //                 },
  //             }
  //         },
  //         thumbs: {
  //             swiper: swiperProduct,
  //         }
  //     });
  // }

  // const mq = window.matchMedia('(min-width: 992px)');
  // mq.addEventListener('change', () => {
  // setTimeout(() => {
  //     swiperProduct2.destroy();
  //     initSwiper();
  // }, 0);
  // });









  // STYLE WITH SLIDER
  var swiperProductStyleWith = new Swiper('.style-with-slider', {
    slidesPerView: 2.3,
    spaceBetween: 10,
    breakpoints: {

      768: {
        slidesPerView: 3.3,
        spaceBetween: 15,
      },
    },
  })
  //YOUR STYLE SECTION SLIDER
  var swiperYourStyle = new Swiper('.your-style-swiper', {
    loop: true,
    speed: 300,
    slidesPerView: 2.3,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints:
    {
      767: {
        centeredSlides: true,
        slidesPerView: 4,
      }
    },
  })
  // RELATED PRODUCTS SLIDER
  var swiper = new Swiper(".mySwiperRelatedProduct", {
    slidesPerView: 2.3,
    spaceBetween: 30,
    freeMode: true,
    grabCursor: true,
    simulateTouch: true,
    touchMoveStopPropagation: true,
    mousewheel: {
      forceToAxis: true,
    },
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
      draggable: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 3.3,
        spaceBetween: 20,
      },
      992: {
        slidesPerView: 4.4,
        spaceBetween: 30,
      }
    },
  });
})